module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "e1362a1c72141_002.2a168a33.webp";